var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42524 3.57464C8.24841 3.39781 7.97051 3.39781 7.79367 3.57464L5.99999 5.36832L4.20631 3.57464C4.02948 3.39781 3.75158 3.39781 3.57474 3.57464C3.3979 3.75148 3.3979 4.02938 3.57474 4.20622L5.36841 5.9999L3.57474 7.79358C3.3979 7.97041 3.3979 8.24831 3.57474 8.42515C3.6632 8.51362 3.77686 8.55151 3.89052 8.55151C4.00419 8.55151 4.11785 8.51362 4.20631 8.42515L5.99999 6.63148L7.79367 8.42515C7.88213 8.51362 7.99579 8.55151 8.10946 8.55151C8.22312 8.55151 8.33678 8.51362 8.42524 8.42515C8.60208 8.24832 8.60208 7.97042 8.42524 7.79358L6.63157 5.9999L8.42524 4.20622C8.58948 4.02938 8.58948 3.75149 8.42524 3.57464Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2189 0H1.78107C0.795809 0 0 0.795809 0 1.78107V10.2189C0 11.2042 0.795809 12 1.78107 12H10.2189C11.2042 12 12 11.2042 12 10.2189V1.78107C12 0.795809 11.2042 0 10.2189 0ZM11.1158 10.2189C11.1158 10.7115 10.7116 11.1158 10.2189 11.1158H1.78107C1.28844 11.1158 0.884185 10.7115 0.884185 10.2189V1.78105C0.884185 1.28842 1.28844 0.884162 1.78107 0.884162H10.2189C10.7116 0.884162 11.1158 1.28842 11.1158 1.78105V10.2189Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilters);
export default __webpack_public_path__ + "static/media/clear-filters.9af9f4f4.svg";
export { ForwardRef as ReactComponent };